function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.175.5H1.087l3.359 3.921z",
  "data-name": "See More",
  stroke: "#000"
});

var SvgSeeMore = function SvgSeeMore(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 9.34 5.167"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/seeMore.b4f9d89a.svg";
export { SvgSeeMore as ReactComponent };